import {
    makeKey,
    update,
    handleApiResponseError,
    handleNetworkError
} from '../../../../utils/reducerOperations';
import {toast} from '../../../../utils/messageUtils';
export function fetchSurveyTableFailed(state, payload) {
    let response = makeKey(
        'fetchSurveyTableApi',
        update(state.fetchSurveyTableApi, {
            ...(payload.response && payload.response.data
                ? handleApiResponseError(payload.response.data)
                : handleNetworkError(payload))
        })
    );
    toast.error(response.fetchSurveyTableApi.message);
    return response;
}
